import VideoErrorInterface from '@videos/errors/video-error.interface';
import { VideoError } from '@videos/errors/video-error';

export default class VideoNotEmbeddableError extends VideoError implements VideoErrorInterface {
    readonly code = 'not-embeddable';
}
